import type { ComponentType } from "react";
import { AccessRequestsToolUI } from "./AccessRequestsCard";
import type { ToolUIProps } from "./ToolUIContext";

// cohort_explorer's get_cohort/create_cohort/update_cohort render in the MCP Apps side
// pane (cohort-app.html), not inline here — see PANE_MCP_SERVER_IDS in useMcpAppsPane.ts.
export const TOOL_UI_REGISTRY: Map<string, ComponentType<ToolUIProps>> = new Map([
  ["cohort_explorer_get_access_requests", AccessRequestsToolUI],
]);
